import {
    altTextTitle,
    altTextInputLabel as altTextInputLabel_1,
} from './imageAltText.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { okButton } from 'owa-locstrings/lib/strings/okbutton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import RibbonPlugin from '../../plugin/RibbonPlugin';

import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { setImageAltText } from 'roosterjs-editor-api';
import { QueryScope } from 'roosterjs-editor-types';

let styles = require('./imageAltText.scss');

const imageAltText: RibbonButton = {
    key: 'imageAltText',
    title: () => loc(altTextTitle),
    imageSrc: require('../svg/imagealttext.svg'),
    buttonState: formatState =>
        formatState.canAddImageAltText ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: showImageAltTextDialogForSelection,
};

export default imageAltText;

async function showImageAltTextDialogForSelection(plugin: RibbonPlugin) {
    let editor = plugin.getEditor();
    let range = editor.getSelectionRange();
    let nodeSelectedByPlugin = await plugin.getImageSelectedByPlugin();
    let node = nodeSelectedByPlugin || editor.queryElements('img', QueryScope.OnSelection)[0];

    plugin.workaroundFocusIssueForFirefox();

    await showImageAltTextDialog(node, alt => {
        editor.select(range);
        if (nodeSelectedByPlugin) {
            nodeSelectedByPlugin.alt = alt;
        } else {
            setImageAltText(editor, alt);
        }
    });
}

export async function showImageAltTextDialog(
    node: HTMLImageElement,
    okCallBack: (alt: string) => void,
    dismissCancelCallBack?: () => void
) {
    if (node) {
        let alt = node.alt;
        let reassignAlt = () => {
            alt = imageAltTextInput.value;
        };
        let imageAltTextInput: HTMLInputElement;
        if (
            DialogResponse.ok ==
            (await confirm(loc(altTextTitle), null /*subText*/, false /*resolveImmediately*/, {
                okText: loc(okButton),
                cancelText: loc(cancelButton),
                bodyElement: (
                    <div>
                        <div className={styles.imagePreviewContainer}>
                            <img src={node.src} className={styles.imagePreview} />
                        </div>
                        <input
                            id="altTextInput"
                            role="textbox"
                            type="text"
                            ref={ref => (imageAltTextInput = ref)}
                            onChange={reassignAlt}
                            defaultValue={alt}
                            className={styles.altTextInputLabel}
                            aria-label={loc(altTextInputLabel_1)}
                        />
                    </div>
                ),
                delayCallbackAfterAnimation: true,
                focusSelector: '#altTextInput',
            }))
        ) {
            okCallBack(alt);
        } else if (dismissCancelCallBack) {
            dismissCancelCallBack();
        }
    }
}
